<template>
  <div class="wrapper">
    <div class="container">
      <Header name="Contacter l'équipe commerciale Yuzu" />
      <div class="card">
        <div class="block">
          <h2>Vous avez besoin de plus d’évaluations ?</h2>
          <p>
            Profitez d’un accompagnement personnalisé de nos experts, pour
            définir l’offre la plus adaptée à votre organisation.
          </p>
        </div>
        <div class="block-avantages">
          <p class="bold">Vos avantages avec un devis sur-mesure :</p>
          <div class="avantages-list">
            <div class="avantage">Tarif préférentiel</div>
            <div class="avantage">Nombre d’utilisateurs illimité</div>
            <div class="avantage">
              Accès illimité à toutes les fonctionnalités
            </div>
          </div>
        </div>
        <p class="bold">
          Contactez-nous et bénéficiez de l’accompagnement d’une équipe de
          passionnés !
        </p>
        <img src="@/assets/images/img/team.webp" alt="Yuzu team" />
      </div>
    </div>
    <div class="form-side">
      <img
        src="@/assets/images/element/lemon.svg"
        alt="Yuzu lemon"
        class="lemon bg-pattern"
      />
      <img
        src="@/assets/images/element/zeste.svg"
        alt="Yuzu zeste"
        class="zeste bg-pattern"
      />
      <img
        src="@/assets/images/element/dots-pattern.svg"
        alt="Yuzu dots pattern"
        class="dots-pattern bg-pattern"
      />
      <img
        src="@/assets/images/element/dots-pattern.svg"
        alt="Yuzu dots pattern"
        class="dots-pattern-2 bg-pattern"
      />
      <div class="card">
        <h4>Formulaire de contact</h4>
        <p>
          Merci de bien vouloir vérifier les informations entrées ci-dessous
          avant d’envoyer le formulaire.
        </p>
        <VForm
          :button="{
            label: 'Envoyer votre message',
            class: 'primary full-size',
            hotDisabled: true,
          }"
          :externalRule="message?.length > 0"
          :callback="submit"
        >
          <template #form-body>
            <div class="input-inline">
              <VField
                :label="$t('form.register.firstName')"
                name="firstname"
                v-model="user.first_name"
                :disabled="true"
              />
              <VField
                :label="$t('form.register.lastName')"
                name="lastname"
                v-model="user.last_name"
                :disabled="true"
              />
            </div>
            <VField
              :label="$t('form.email')"
              type="email"
              name="email"
              v-model="user.email"
              :disabled="true"
            />
            <div class="input-wrapper">
              <label for="phone">{{ $t("form.register.phone") }}</label>
              <vue-tel-input
                id="phone"
                v-model="user.phone_number"
                :disabled="true"
              >
                <template v-slot:arrow-icon>
                  <i class="bi bi-chevron-down" />
                </template>
              </vue-tel-input>
            </div>
            <VTextarea
              name="message"
              rows="3"
              :modelValue="message"
              @input="(event) => (message = event.target.value)"
            />
            <p class="small">
              <span class="bold">Yuzu</span> a besoin de vos coordonnées pour
              vous contacter au sujet de ses produits et services. Vous pouvez
              vous désabonner de ces communications à tout moment.
            </p>
          </template>
        </VForm>
      </div>
    </div>
  </div>
</template>

<script setup>
import Header from "@/components/Header.vue";
import { useUserStore } from "@/stores/user.js";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import { ref } from "vue";
import { getError } from "@/composables/error.js";

const { user, contact } = useUserStore();

const toast = useToast();

const route = useRoute();

const message = ref(null);

async function submit() {
  if (!message.value) return;

  const resp = await contact(route.params.companyId, message.value);

  if (resp.key) {
    toast.error(getError(resp.key));
  } else {
    toast.success(
      "Nous vous informons que notre équipe a bien reçu votre demande. Nous vous contacterons dans les plus brefs délais."
    );
  }

  message.value = "";
}
</script>
